import { render, staticRenderFns } from "./NewIndexTabContainer.vue?vue&type=template&id=4c18f821&"
import script from "./NewIndexTabContainer.vue?vue&type=script&lang=js&"
export * from "./NewIndexTabContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports